<template>
  <div class="payment-status">
        <XCircleIcon class="payment-icon"/>
        <div class="payment-message">
            Sorry. Payment Had Failed
        </div>
        <div class="trans-id">
            <div class="trans">
                Transaction ID:
            </div>
            <div class="trans">
                {{ txRef }}
            </div>
        </div>
    </div>
</template>
<script>
import PageHeader from '@/components/Utility/PageHeader.vue';
import XCircleIcon from '@/components/IconComponents/XCircleIcon.vue';

export default {
    components:{
        PageHeader, XCircleIcon
    },
    data(){
        return{
            txRef:""
        }
    },
    mounted(){
        this.txRef =  this.$route.query.tx_ref;
    }
}
</script>
<style scoped>
    .payment-status{
    margin-top:3rem;
    margin-bottom:5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.trans-id{
    display: flex;
    flex-direction: column;
    align-items: center;
    
}

.trans:first-child{
    font-size:0.8rem;
}

.trans:last-child{
    font-size:0.9rem;
}

.payment-icon, .payment-message{
    color:var(--red);
}

.payment-message{
    font-size:1.4rem;
    margin-bottom:1rem;
}

.payment-icon{   
    height:5rem;
    width:5rem;
    margin-bottom:1rem;
}

.payment-message{
    font-family: var(--heading-font-bold);
}

@media(max-width:768px){
    .payment-icon{   
    height:4rem;
    width:4rem;
    margin-bottom:0.6rem;
}

.payment-message{
    font-size:1.2rem;
}

}
</style>